export const checkPriceCategory = (
  space: { venue: { priceCategory: string } },
  priceCategoryFilter: Record<string, boolean>,
) => {
  if (Object.values(priceCategoryFilter).every((filter) => !filter)) {
    return true;
  }

  return priceCategoryFilter[space.venue.priceCategory];
};
